import { createApi } from "redux-future-middleware";
import { requestApi } from "core/api";
import * as types from "./types";
import * as endpoints from "./endpoints";

export const deleteSubObjective = createApi({
  name: types.DELETE_SUB_OBJECTIVE,
  request: ({ bookingId, sub_objective, label }) =>
    requestApi({
      path: `/insiders/bookings/${bookingId}/`,
      method: "PATCH",
      body: {
        sub_objective,
        label
      }
    })
});

export const applyPromoCode = createApi({
  name: types.APPLY_PROMO_CODE,
  request: ({ bookingId, promo_code, insiderId }) =>
    requestApi({
      path: `/insiders/bookings/${bookingId}/apply-coupon/`,
      method: "POST",
      body: {
        promo_code,
        insiderId
      }
    })
});
export const getBookingInfo = createApi({
  name: types.GET_BOOKING_INFO,
  request: () =>
    requestApi({
      path: "/insiders/bookings/",
      method: "GET"
    })
});

export const getBookingDetail = createApi({
  name: types.GET_BOOKING_DETAIL,
  request: ({ id }) =>
    requestApi({
      path: `/insiders/bookings/${id}/?compact=1`,
      method: "GET"
    })
});

export const bookTime = createApi({
  name: types.BOOK_TIME,
  request: endpoints.bookTime,
  dictionary: ({ insiderId }) => insiderId
});

export const rescheduleBooking = createApi({
  name: types.RESCHEDULE_BOOKING,
  request: ({ bookingId, timeSlotId }) =>
    requestApi({
      method: "PATCH",
      path: `/insiders/bookings/${bookingId}/reschedule/`,
      body: {
        time_slot: timeSlotId
      }
    })
});

export const cancelBooking = createApi({
  name: types.CANCEL_BOOKING,
  request: ({ id }) =>
    requestApi({
      method: "PATCH",
      path: `/insiders/bookings/${id}/cancel/`
    })
});

export const getBookedCalls = createApi({
  name: types.GET_BOOKED_CALLS,
  request: () =>
    requestApi({
      method: "GET",
      path: "/insiders/booking-dashboard/"
    })
});

export const getBookedCallDetail = createApi({
  name: types.GET_BOOKED_CALL_DETAIL,
  request: ({ id }) =>
    requestApi({
      method: "GET",
      path: `/insiders/booking-dashboard/${id}/`
    })
});

export const getWaitingForFeedbackInsiders = createApi({
  name: types.GET_WAITING_FOR_FEEDBACK_INSIDERS,
  request: () =>
    requestApi({
      method: "GET",
      path: "/insiders/booking-dashboard/need-review/"
    })
});

export const getCallObjectives = createApi({
  name: types.GET_CALL_OBJECTIVES,
  request: () =>
    requestApi({
      method: "GET",
      path: "/insiders/call-objectives/"
    })
});



// WEBPACK FOOTER //
// ./src/modules/booking/api.js